import { rem } from 'polished';
import styled from 'styled-components';
import { CheckoutAssistedFinanceStyled } from '../CheckoutAssistedFinanceStyled';

export const CheckoutAssistedFinanceStyledAC = styled(CheckoutAssistedFinanceStyled)`
   
`;
